exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"colorUnknown": "#0087e6",
	"colorOutstanding": "#74d17f",
	"colorStrong": "#74d17f",
	"colorOnTrack": "#f7932d",
	"colorNeedsImprovement": "#de4c4c",
	"colorExperiencingDifficulty": "#de4c4c"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/RadialScoreDisplay/style.postcss
// module id = 1265
// module chunks = 0